/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_CodeInputs */

const vi_warehouse_position_code = /** @type {(inputs: Warehouse_Position_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã vị trí`)
};

/**

* @param {Warehouse_Position_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_code = /** @type {((inputs?: Warehouse_Position_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_code(inputs)
});